<template>
  <div class="cuerpo">
    <EstadoActual></EstadoActual>
  </div>
</template>

<script>
import EstadoActual from "@/components/EstadoActual.vue";

export default {
  name: "MovimientosView",
  components: {
    EstadoActual,
  },
};
</script>

<style></style>
